/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query'
import { getEntryById } from '~/lib/contensis/misc'
import { useLayoutItems } from '..'

import StandardText from '~/components/Text/StandardText/StandardText'
import BlockQuote from '~/components/Content/BlockQuote/BlockQuote'
import GeneralAccordion from '~/components/Content/Accordion/GeneralAccordion'
import TertiaryLinkBlock from '~/components/Content/TertiaryLinkBlock/TertiaryLinkBlock'
import FeatureList from '~/components/Content/FeatureList/FeatureList'
import ImageBlock from '~/components/Media/Core/Images/ImageBlock/ImageBlock'
import TextBlock from '~/components/Content/TextBlock/Core/TextBlock'
import VideoLauncher from '~/components/Media/Core/Video/VideoLauncher/VideoLauncher'
import LargeStatistic from '~/components/Content/LargeStatistic/LargeStatistic'
import ContainedCarousel from '~/components/Carousels/Core/Contained/ContainedCarousel'
import Loader from '~/components/UI/General/Loader/Loader'

type EntriesProps = {
  block: any
  backgroundColour?: string
}

const componentMap: Record<string, React.ComponentType<any>> = {
  textStandardCT: StandardText,
  textPullQuote: BlockQuote,
  contentAccordions: GeneralAccordion,
  contentTertiaryLinkBlock: TertiaryLinkBlock,
  contentFeatureList: FeatureList,
  contentLargeStatistic: LargeStatistic,
  contentTextBlock: TextBlock,
  carouselContained: ContainedCarousel,
  assetImage: ImageBlock,
  // mediaVideoLauncher: VideoLauncher,
  assetVideo: VideoLauncher
} as any

function EntryContent(props: EntriesProps) {
  const blockData = props.block?.value || props.block
  const blockId = props?.block?.value?.sys.id || props?.block?.sys.id
  const backgroundColour = props.backgroundColour || blockData?.backgroundColour

  const { data, isLoading, error } = useQuery({
    queryKey: ['canvas-entry', blockId],
    queryFn: async () => getEntryById(blockId),
    enabled: !!blockId
  })

  const layoutColour = useLayoutItems()

  if (isLoading)
    return (
      <div className='flex w-full justify-center'>
        <Loader fill={'#f5b6dc'} />
      </div>
    )
  if (error || !data) return <div>Error loading entry</div>

  const Component = componentMap[data?.sys?.contentTypeId]
  if (!Component) return <div>Unknown component type</div>

  if (data?.sys?.contentTypeId === 'assetImage')
    return (
      <Component
        content={{
          ...data,
          brandDeviceColour: 'white',
          brandDevicePosition: 'position-4'
        }}
        className={'mb-l'}
      />
    )

  if (data?.sys?.contentTypeId === 'assetVideo') {
    return <Component content={data} />
  }

  return (
    <Component
      content={{
        ...data,
        backgroundColour: backgroundColour || data?.backgroundColour
      }}
      layoutColour={layoutColour.layoutColour}
      alignment={layoutColour?.alignment || 'left'}
      canvas={true}
    />
  )
}

export default EntryContent
